import { h } from 'preact'
import { memo } from 'preact/compat'
import Header from 'components/Header'
import './index.sass'


export const DayBreak = memo(({ day }) => <Header size="sm" className="OrganizationChatPage-DayBreak">{day}</Header>
)
